import { Component, OnInit } from '@angular/core';
import { ExpenseService } from '../expense.service';
import { Expense } from '../expense';
import { Router } from '@angular/router';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css'],
  providers: [ExpenseService]
})
export class ExpenseComponent implements OnInit {

	expenses: Expense[];

  constructor(private expenseService: ExpenseService,private router: Router) { }

  ngOnInit() {
  	this.expenseService.getExpense().subscribe(response=>{this.expenses=response['data'];});
  }


  clicked():void {
   		this.router.navigate(['/dashboard/expense-crud']);
  }  

  clickedId(id: any){
    	 this.router.navigate(['/dashboard/expense-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expenses/expense/expense.component.ts